import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import visionIcon from '../../../../assets/images/about/purpose/ic1.svg';
import missionIcon from '../../../../assets/images/about/purpose/ic2.svg';
import topImage from '../../../../assets/images/about/purpose/top.jpg';
import bottomImage from '../../../../assets/images/about/purpose/bottom.jpg';
import './Purpose.css';

const missionItems = [
  'Deliver strategic financial insights for informed decisions.',
  'Integrate technology to improve efficiency and clarity.',
  'Build enduring relationships based on trust and collaboration.',
  'Support sustainable growth and adaptability in dynamic markets.',
];

const Purpose = () => {
  return (
    <section className="purpose">
      <div className="purpose__inner">
        <Reveal className="purpose__header">
          <p className="purpose__eyebrow">Purpose</p>
          <h2 className="purpose__title">Vision &amp; Mission.</h2>
        </Reveal>

        <div className="purpose__rows">
          <Reveal className="purpose__row">
            <article className="purpose__content">
              <div className="purpose__icon">
                <img src={visionIcon} alt="" aria-hidden="true" />
              </div>
              <h3 className="purpose__heading">Our Vision</h3>
              <p className="purpose__text">
                To be a guiding force for financial excellence and resilience —
                empowering clients to thrive through volatility and change. We
                aim to build enduring partnerships grounded in trust,
                innovation, and long-term success.
              </p>
            </article>

            <div className="purpose__media">
              <img
                className="purpose__image"
                src={topImage}
                alt=""
                aria-hidden="true"
              />
            </div>
          </Reveal>

          <Reveal className="purpose__row purpose__row--reverse" delay={80}>
            <div className="purpose__media">
              <img
                className="purpose__image"
                src={bottomImage}
                alt=""
                aria-hidden="true"
              />
            </div>

            <article className="purpose__content">
              <div className="purpose__icon">
                <img src={missionIcon} alt="" aria-hidden="true" />
              </div>
              <h3 className="purpose__heading">Our Mission</h3>
              <p className="purpose__text">
                To empower clients to navigate financial complexity with
                excellence, innovation, and resilience.
              </p>
              <ul className="purpose__list">
                {missionItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Purpose;
